module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAlCAMAAADyQNAxAAAAOVBMVEVMaXEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABjXQ0ZAAAAEnRSTlMAagph9K2bWlUn1vC7Q+G+i4yXnbIaAAAAi0lEQVR42u2U3QqAIAxGlzpr/mT5/g+bRbSLmHpjV52LweDAPmUMgNDnGh6pSOyIHgHmNgi+wzJwVqhwCUOtufTzb31tbclOcSp9qTbtgqVcZpySJpLhlSI5l34sXUtvb8nK6TmaU6LF0Qy1/kuHEPQ3e59frIOt5UUc8sa+m9N3vzpvIRCa+jgkOACOwi9L1d/K6wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/mobileb/ic_xz.png
// module id = DARJ
// module chunks = 1